import type { Connection, MatterLien } from "@/lib/types";
import {
  createContactConnectionChildInput,
  getActiveContactConnections,
} from "./item-contact-connections";

export const LIEN_CONTACT_CONNECTION_TYPES = {
  "Lien Holder": "matter_lien_to_lien_holder",
  "Lien Representative": "matter_lien_to_lien_representative",
} as const;

export type SupportedLienContactRole =
  keyof typeof LIEN_CONTACT_CONNECTION_TYPES;

export const getLienContactConnections = (
  lien: MatterLien | undefined,
  role: SupportedLienContactRole,
): Connection[] =>
  getActiveContactConnections(
    lien,
    "matter_lien",
    LIEN_CONTACT_CONNECTION_TYPES[role],
  );

export const getLienContactConnection = (
  lien: MatterLien | undefined,
  role: SupportedLienContactRole,
): Connection | undefined => getLienContactConnections(lien, role)[0];

export const createLienContactConnectionChildInput = (
  contactId: string,
  role: SupportedLienContactRole,
) =>
  createContactConnectionChildInput(
    contactId,
    LIEN_CONTACT_CONNECTION_TYPES[role],
  );
